/**
 * ColegaLink — Sonidos oficiales de notificación
 * Solo 2 opciones (archivos MP3 pregrabados y aprobados por el equipo).
 */

const SOUND_FILES = {
  voz: "/sounds/colegalink-voz.mp3",           // Firma + voz "Colega Link"
  vozOff: "/sounds/colegalink-voz-off.mp3",    // Firma sin voz
};

export const SOUND_KEYS = {
  voz: "voz",
  vozOff: "vozOff",
};

// Cache de Audio elements para evitar recrearlos en cada disparo
const _cache = {};
function getAudio(key) {
  if (typeof window === "undefined") return null;
  if (!_cache[key]) {
    const a = new Audio(SOUND_FILES[key]);
    a.preload = "auto";
    _cache[key] = a;
  }
  return _cache[key];
}

export function playSound(key) {
  const file = SOUND_FILES[key] || SOUND_FILES.voz;
  const cacheKey = SOUND_FILES[key] ? key : "voz";
  const audio = getAudio(cacheKey);
  if (!audio) return;
  try {
    audio.currentTime = 0;
    const p = audio.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => { /* autoplay bloqueado por navegador */ });
    }
  } catch (_) { /* noop */ }
}

/* ============================================================
 *  Preferencia de usuario (por dispositivo, en localStorage)
 * ============================================================ */
const LS_KEY = "colegalink.notification.sound";
const LS_ENABLED_KEY = "colegalink.notification.sound.enabled";

export function getPreferredSound() {
  if (typeof window === "undefined") return "voz";
  const v = window.localStorage.getItem(LS_KEY);
  // Sólo aceptamos los 2 valores oficiales. Cualquier valor antiguo se mapea a "voz"
  if (v === "voz" || v === "vozOff") return v;
  return "voz";
}
export function setPreferredSound(key) {
  if (typeof window === "undefined") return;
  const safe = key === "vozOff" ? "vozOff" : "voz";
  window.localStorage.setItem(LS_KEY, safe);
}

export function isSoundEnabled() {
  if (typeof window === "undefined") return true;
  const v = window.localStorage.getItem(LS_ENABLED_KEY);
  return v === null ? true : v === "1";
}
export function setSoundEnabled(enabled) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LS_ENABLED_KEY, enabled ? "1" : "0");
}

export function playPreferredSound() {
  if (!isSoundEnabled()) return;
  playSound(getPreferredSound());
}

export const SOUND_FILE_URLS = SOUND_FILES;
